import React, { useEffect, useRef } from 'react';
import './PhoneInput.css'; // CSS imported separately

const PhoneInput = ({ phone, setPhone }) => {
  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    if (value.length <= 10) setPhone(value);
  };



  const inputRef = useRef(null);

  useEffect(() => {
    // Safely focus if the element exists
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);


  return (
    <div className="phone-input-wrapper">
      <span className="country-code">&nbsp;&nbsp;+91&nbsp;&nbsp;</span>
      <div className="separator" />
      <input
        type="tel"
        ref={inputRef}
        placeholder="Mobile no."
        className="mobile-input"
        maxLength={10}
        minLength={10}
        value={phone}
        onChange={handleChange}
      />
    </div>
  );
};

export default PhoneInput;
